/*
  HAPPE BOX V3 - Enterprise Theme Core Orchestrator (theme.js)
  Integrates events, storage, observers, page routers, and component registries.
*/

window.Happe = {
  version: "3.0.0",
  
  // 1. Theme Context Layer
  Context: window.HappeContext || {
    template: 'index',
    page_type: 'index',
    locale: 'en',
    currency: 'QAR',
    customer_logged_in: false
  },

  // 2. Services Registry
  Services: {},

  // 3. Logger Service
  Logger: {
    level: 'info', // 'debug' | 'info' | 'warn' | 'error'
    debug(msg, data = '') { if (this.level === 'debug') console.debug('[Happe DEBUG]', msg, data); },
    info(msg, data = '') { console.info('[Happe INFO]', msg, data); },
    warn(msg, data = '') { console.warn('[Happe WARN]', msg, data); },
    error(msg, data = '') { console.error('[Happe ERROR]', msg, data); }
  },

  // 4. Component Registries
  Components: {
    registry: {},
    register(metadata, compClass) {
      this.registry[metadata.name] = { class: compClass, metadata };
      Happe.Logger.debug(`Registered component: ${metadata.name} v${metadata.version}`);
    },
    init() {
      Happe.Logger.debug('Initializing component registry...');
      Object.keys(this.registry).forEach(name => {
        const item = this.registry[name];
        if (item.metadata.autoload) {
          const elements = document.querySelectorAll(item.metadata.selector);
          elements.forEach(el => {
            try {
              new item.class(el);
            } catch (e) {
              Happe.Logger.error(`Failed to load component "${name}":`, e);
            }
          });
        }
      });
    }
  },

  // 5. Page Controller Routing
  Pages: {
    init() {
      const pageType = Happe.Context.page_type;
      Happe.Logger.info(`Page Router executing for pageType: ${pageType}`);
      
      if (this[pageType]) {
        try {
          this[pageType]();
        } catch (e) {
          Happe.Logger.error(`Error running Page Handler for ${pageType}`, e);
        }
      }
    },
    index() {
      Happe.Logger.info('Homepage controller active');
      // Initialize homepage specific modules here
    },
    product() {
      Happe.Logger.info('Product details page controller active');
    },
    builder() {
      Happe.Logger.info('Builder configuration controller active');
    }
  }
};

// 6. Universal Slider/Carousel Component
class HappeCarousel {
  constructor(element) {
    this.element = element;
    this.track = element.querySelector('.hp-carousel-track');
    this.autoplay = element.dataset.autoplay === 'true';
    this.speed = parseInt(element.dataset.speed || 4) * 1000;
    this.init();
  }

  init() {
    if (this.autoplay) {
      this.startAutoplay();
    }
  }

  startAutoplay() {
    setInterval(() => {
      const slide = this.element.querySelector('.hp-carousel-slide');
      if (!slide) return;
      const slideWidth = slide.offsetWidth + 15;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      if (this.track.scrollLeft >= maxScroll - 5) {
        this.track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        this.track.scrollBy({ left: slideWidth, behavior: 'smooth' });
      }
    }, this.speed);
  }
}

// Autowire bootstrap sequences on DOM load
function bootstrapHappe() {
  if (window.Happe_Bootstrapped) return;
  window.Happe_Bootstrapped = true;

  Happe.Logger.info('Bootstrapping Happe Framework V3...');
  
  // Initialize Utilities on global namespace
  Happe.Events = new window.HappeEventBusClass();
  Happe.Storage = new window.HappeStorageClass();
  Happe.Observer = new window.HappeObserverClass();
  Happe.Animation = new window.HappeAnimationClass();

  // Register components in registry
  Happe.Components.register({
    name: 'carousel',
    version: '1.0',
    selector: '.js-carousel-container',
    autoload: true
  }, HappeCarousel);

  // Run Registries and Page Routers
  Happe.Components.init();
  Happe.Pages.init();

  Happe.Events.emit('theme:ready');
  Happe.Logger.info('Happe Framework V3 ready.');
  
  // Initialize Global Wishlist
  if (window.HappeWishlist) {
    window.HappeWishlist.init();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrapHappe);
} else {
  bootstrapHappe();
}

// Happe Box Wishlist State Manager
window.HappeWishlist = {
  get() {
    try {
      return JSON.parse(localStorage.getItem('hp_wishlist') || '[]');
    } catch(e) {
      return [];
    }
  },

  set(list) {
    try {
      localStorage.setItem('hp_wishlist', JSON.stringify(list));
    } catch(e) {}
  },

  has(handle) {
    return this.get().includes(handle);
  },

  toggle(handle) {
    let list = this.get();
    if (list.includes(handle)) {
      list = list.filter(h => h !== handle);
    } else {
      list.unshift(handle);
      if (list.length > 50) list.pop(); // Max 50 items
    }
    this.set(list);
    this.updateUI();

    // Trigger tab reload if we are on the account page
    const wishlistGrid = document.getElementById('hp-wishlist-grid');
    if (wishlistGrid && window.HappeAccountLoadWishlist) {
      window.HappeAccountLoadWishlist();
    }
  },

  updateUI() {
    this.updateBadges();
    this.updateButtons();
  },

  updateBadges() {
    if (window.hpSyncWishlistCount) {
      window.hpSyncWishlistCount();
    } else {
      const count = this.get().length;
      document.querySelectorAll('.wishlist-count').forEach(badge => {
        badge.textContent = count;
        badge.style.display = count > 0 ? 'inline-flex' : 'none';
      });
    }
  },

  updateButtons() {
    const list = this.get();
    
    // Style PDP and card buttons
    document.querySelectorAll('.hp-wishlist-toggle-btn').forEach(btn => {
      const handle = btn.getAttribute('data-handle');
      const isActive = list.includes(handle);
      
      if (isActive) {
        btn.classList.add('active');
        const svgPath = btn.querySelector('svg path');
        if (svgPath) {
          svgPath.setAttribute('fill', '#7d907c');
          svgPath.setAttribute('stroke', '#7d907c');
        }

        // Custom styling for PDP detail page button
        if (btn.classList.contains('hp-pdp-btn-wishlist')) {
          const btnText = btn.querySelector('.wishlist-btn-text');
          const isAr = window.location.pathname.startsWith('/ar') || document.documentElement.getAttribute('dir') === 'rtl';
          if (btnText) btnText.textContent = isAr ? 'في المفضلة' : 'In Wishlist';
          btn.style.background = '#fff0f3';
          btn.style.borderColor = '#7d907c';
        }
      } else {
        btn.classList.remove('active');
        const svgPath = btn.querySelector('svg path');
        if (svgPath) {
          svgPath.setAttribute('fill', 'none');
          svgPath.setAttribute('stroke', 'currentColor');
        }

        // Custom styling for PDP detail page button
        if (btn.classList.contains('hp-pdp-btn-wishlist')) {
          const btnText = btn.querySelector('.wishlist-btn-text');
          const isAr = window.location.pathname.startsWith('/ar') || document.documentElement.getAttribute('dir') === 'rtl';
          if (btnText) btnText.textContent = isAr ? 'المفضلة' : 'Add to Wishlist';
          btn.style.background = '#faf8f5';
          btn.style.borderColor = '#eae3d7';
        }
      }
    });
  },

  init() {
    this.updateUI();

    // Event Delegation for clicks
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.hp-wishlist-toggle-btn');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        const handle = btn.getAttribute('data-handle');
        if (handle) {
          this.toggle(handle);
        }
      }
    });
  }
};

